"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import { caseStudies } from "src/utils/mock/caseStudies";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import { nodeFaqs, nodeHeroData, nodeStatsData, nodeSolutionsAndProcessData, nodePortfolioData, nodeTechnologiesData, nodeAboutData } from "src/utils/mock/nodeAppData";

export default function NodeJSDevelopment({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const nodeProjects = liveProjects.filter((project) => {
    const isActive = project.projectStatus === "active";
    const webApp = project.platforms?.toLowerCase().includes("web") || project.platforms?.toLowerCase().includes("mobile");

    const hasNodeTech = project.technologies?.some(
      (tech) => tech.name?.toLowerCase().includes("nodejs") || tech.name?.toLowerCase().includes("node js") || tech.name?.toLowerCase() === "node",
    );

    return isActive && webApp && hasNodeTech;
  });

  const filteredData = {
    ...nodePortfolioData,
    projects: {
      liveProjects: nodeProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={nodeHeroData} />

      <TechStats stats={nodeStatsData} />

      <WhyChooseUs data={nodeSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />

          <ProcessStepsSection data={nodeTechnologiesData} techIcons={techIcons} />

          <TechsSection sections={nodeAboutData} mainTitle="About NodeJS Development" />
        </div>
      </section>

      <FAQSection faqs={nodeFaqs} />
      <CommonContactSection />
    </div>
  );
}
